import { render } from "./windowBtn.vue?vue&type=template&id=e09ebbba&scoped=true"
import script from "./windowBtn.vue?vue&type=script&lang=js"
export * from "./windowBtn.vue?vue&type=script&lang=js"

import "./windowBtn.vue?vue&type=style&index=0&id=e09ebbba&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e09ebbba"

export default script